import { defineStore } from 'pinia'
import { type IApiInstance } from '../plugins/api'
import {
  BLOOD_PRESSURE_CODE,
  INSULINE_CODE,
  RepresentationTypeEnum,
  type ObservationDefinition,
} from '~/repository/types/directus/observationDefinition'
import _ from 'lodash'
import type { UIObservationDefinition } from '~/repository/types/UIObservation'

export type IObservationDefintionsState = {
  isLoaded: boolean
  definitions: UIObservationDefinition[]
}

const createBloodPressureDef = (bloodPressureDef: UIObservationDefinition | undefined) => {
  if (!bloodPressureDef) return
  bloodPressureDef = _.cloneDeep(bloodPressureDef)
  bloodPressureDef!.code = BLOOD_PRESSURE_CODE
  bloodPressureDef!.translations[0].short_name = 'PA'
  bloodPressureDef!.translations[0].name = 'Pression Artérielle'
  return bloodPressureDef
}
const createInsulinePressureDef = () => {
  let insulineDef = {} as UIObservationDefinition
  insulineDef!.code = INSULINE_CODE
  insulineDef!.color = '#000000'
  insulineDef.range_max = 10
  insulineDef.range_min = 0
  insulineDef.unit = ''
  insulineDef.type = 'float'
  insulineDef!.translations = [{ short_name: 'INSULINE', name: `Prise d'Insuline`, id: 999, description: '' }]
  return insulineDef
}

export const useObservationDefinitionsStore = defineStore('observationDefinitions', {
  state: (): IObservationDefintionsState => {
    return {
      isLoaded: false,
      definitions: [],
    }
  },
  getters: {
    getByCode: (state) => (code: string) => {
      return state.definitions.find((t: UIObservationDefinition) => t.code === code)
    },
    getDictonnaryForChart:
      (state) =>
      (codeExcludes: string[]): { [observationCode: string]: UIObservationDefinition } => {
        let definitionsForChart: UIObservationDefinition[] = []

        definitionsForChart = _.filter(state.definitions, (def) => {
          return _.indexOf(codeExcludes, def.code) == -1
        })

        const observationsDefinition: { [observationCode: string]: UIObservationDefinition } = {}
        definitionsForChart.forEach((obs: UIObservationDefinition) => {
          observationsDefinition[obs.code] = obs
        })

        return observationsDefinition
      },
  },
  actions: {
    async load() {
      const api: IApiInstance = useNuxtApp().$api as IApiInstance

      this.definitions = await api.cms.getObservationDefinitions()

      let bloodPressureDef: UIObservationDefinition | undefined = _.find(this.definitions, (obs) => {
        return obs.representation == RepresentationTypeEnum.bloodPressure
      })
      this.definitions.push(createBloodPressureDef(bloodPressureDef))
      this.definitions.push(createInsulinePressureDef())
      this.definitions.forEach((defintion: UIObservationDefinition) => {
        defintion.visible = true
      })
      if (this.definitions) {
        this.isLoaded = true
      }
    },
    /**
     * An action to clear the user data from the storage, should be used upon signing out the user.
     *
     * @param {object} context - VueX store context containing commit helper for mutations.
     */
    clear() {
      this.$reset()
    },
  },
})
